import { TranslationKeys } from '../index'

export const zhCN: TranslationKeys = {
  // 通用
  common: {
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    remove: '移除',
    clear: '清空',
    reset: '重置',
    import: '导入',
    export: '导出',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',
    unknown: '未知',
    zoom: '缩放',
    close: '关闭',
    ok: '确定'
  },
  
  // 头部
  header: {
    title: 'Markdown 表格编辑器',
    new: '新建',
    open: '打开',
    save: '保存',
    export: '导出',
    undo: '撤销',
    redo: '重做',
    settings: '设置',
    help: '帮助',
    shortcuts: '快捷键帮助',
    guide: '使用指南',
    about: '关于页面',
    toggleSidebar: '切换侧边栏 (F11)',
    importFile: '导入文件 (Ctrl+O)',
    exportFile: '导出文件',
    undoAction: '撤销 (Ctrl+Z)',
    redoAction: '重做 (Ctrl+Shift+Z)',
    saveMarkdown: '保存为 Markdown (Ctrl+S)',
    settingsTooltip: '设置',
    helpTooltip: '帮助',
    shortcutsHelp: '快捷键帮助',
    userGuide: '使用指南',
    aboutApp: '关于应用',
    shortcutsNotImplemented: '快捷键功能未实现',
    guideNotImplemented: '使用指南未实现',
    aboutNotImplemented: '关于页面未实现'
  },
  
  // 侧边栏
  sidebar: {
    files: '文件',
    history: '历史',
    settings: '设置',
    style: '样式',
    tableInfo: '表格信息',
    rows: '行数',
    columns: '列数',
    cells: '单元格',
    lastModified: '最后修改'
  },

  // 样式面板
  style: {
    backgroundColor: '背景颜色',
    textColor: '文字颜色',
    fontColor: '字体颜色',
    fontStyle: '字体样式',
    fontSize: '字体大小',
    padding: '内边距',
    textStyle: '文字样式',
    bold: '粗体',
    italic: '斜体',
    underline: '下划线',
    alignment: '对齐方式',
    leftAlign: '左对齐',
    centerAlign: '居中对齐',
    rightAlign: '右对齐',
    borderStyle: '边框样式',
    borderColor: '边框颜色',
    borderWidth: '边框宽度',
    borderType: '边框样式',
    solid: '实线',
    dashed: '虚线',
    dotted: '点线',
    double: '双线',
    none: '无边框',
    stylePreview: '样式预览',
    resetStyle: '重置样式',
    presetColors: '预设颜色',
    sampleText: '示例文本'
  },
  
  // 设置面板
  settings: {
    appearance: '外观设置',
    darkMode: '深色模式',
    language: '界面语言',
    fontSize: '字体大小',
    editor: '编辑器设置',
    autoSave: '自动保存',
    autoSaveInterval: '自动保存间隔（秒）',
    showLineNumbers: '显示行号',
    syntaxHighlight: '语法高亮',
    wordWrap: '自动换行',
    table: '表格设置',
    defaultAlignment: '默认对齐方式',
    showGridLines: '显示网格线',
    alternateRowColors: '交替行颜色',
    resizableColumns: '可调整列宽',
    maxHistorySize: '最大历史记录数',
    importExport: '导入导出设置',
    defaultExportFormat: '默认导出格式',
    exportWithStyles: '导出时包含样式',
    compressExports: '压缩导出文件',
    performance: '性能设置',
    enableVirtualScrolling: '启用虚拟滚动',
    lazyRendering: '延迟渲染',
    renderDelay: '渲染延迟（毫秒）',
    management: '设置管理',
    saveSettings: '保存设置',
    loadSettings: '加载设置',
    exportSettings: '导出设置',
    importSettings: '导入设置',
    resetToDefault: '恢复默认设置',
    settingsSaved: '设置已保存',
    settingsLoaded: '设置已加载',
    settingsReset: '设置已重置',
    settingsExported: '设置已导出',
    settingsImported: '设置已导入',
    noSavedSettings: '没有保存的设置',
    saveSettingsFailed: '保存设置失败',
    loadSettingsFailed: '加载设置失败',
    exportSettingsFailed: '导出设置失败',
    importSettingsFailed: '导入设置失败',
    checkFileFormat: '请检查文件格式是否正确'
  },
  
  // 编辑器状态
  editor: {
    unsavedChanges: '未保存的更改',
    characterCount: '字符数',
    lineCount: '行数',
    validTable: '有效表格'
  },

  // 表格编辑
  table: {
    addRow: '添加行',
    addColumn: '添加列',
    deleteRow: '删除行',
    deleteColumn: '删除列',
    alignLeft: '左对齐',
    alignCenter: '居中对齐',
    alignRight: '右对齐',
    copy: '复制',
    paste: '粘贴',
    cut: '剪切',
    clear: '清空',
    merge: '合并单元格',
    split: '拆分单元格',
    parseError: '表格解析失败',
    unknownError: '未知错误',
    edit: '编辑',
    preview: '预览',
    line: '行',
    applyChanges: '应用更改',
    reset: '重置',
    copyContent: '复制内容',
    downloadMarkdown: '下载 Markdown',
    placeholder: '在此输入 Markdown 表格内容...'
  },
  
  // 视图模式
  view: {
    table: '表格视图',
    markdown: 'Markdown 视图',
    preview: '预览模式',
    split: '分屏模式',
    tableEditor: '表格编辑器',
    markdownEditor: 'Markdown 编辑器',
    previewPane: '预览',
    markdownPreview: 'Markdown',
    htmlPreview: 'HTML'
  },
  
  // 导出
  export: {
    markdown: 'Markdown',
    csv: 'CSV',
    excel: 'Excel',
    html: 'HTML',
    json: 'JSON',
    png: 'PNG',
    svg: 'SVG',
    exportSuccess: '导出成功',
    exportError: '导出失败',
    unsupportedFormat: '不支持的格式'
  },
  
  // 历史记录
  history: {
    undo: '撤销',
    redo: '重做',
    undoSuccess: '撤销成功',
    redoSuccess: '重做成功',
    noUndoOperations: '没有可撤销的操作',
    noRedoOperations: '没有可重做的操作',
    clearHistory: '清空历史记录',
    historyManaged: '历史记录已管理'
  },
  
  // 文件管理
  files: {
    newFile: '新建文件',
    fileName: '文件名',
    fileDescription: '文件描述',
    createFile: '创建文件',
    deleteFile: '删除文件',
    renameFile: '重命名文件',
    duplicateFile: '复制文件',
    fileCreated: '文件已创建',
    fileDeleted: '文件已删除',
    fileRenamed: '文件已重命名',
    fileDuplicated: '文件已复制',
    search: '搜索文件',
    noFiles: '暂无文件',
    preview: '预览',
    save: '保存',
    searchPlaceholder: '搜索文件...',
    importFile: '导入文件',
    uploadHint: '点击或拖拽文件到此区域上传',
    supportedFormats: '支持 .md, .csv, .xlsx, .json 格式',
    fileList: '文件列表',
    current: '当前',
    copy: '复制',
    export: '导出',
    deleteConfirm: '确定要删除这个文件吗？',
    ok: '确定',
    cancel: '取消',
    close: '关闭',
    openFile: '打开文件',
    fileSize: '文件大小',
    createTime: '创建时间',
    modifyTime: '修改时间',
    tableSize: '表格大小',
    markdownPreview: 'Markdown 预览',
    rows: '行',
    columns: '列',
    enterFileName: '请输入文件名',
    pleaseEnterFileName: '请输入文件名',
    fileCreatedSuccess: '已创建文件',
    fileOpenedSuccess: '已打开文件',
    noOpenFile: '没有打开的文件',
    fileNotExist: '文件不存在',
    fileSavedSuccess: '已保存文件',
    fileDeletedSuccess: '已删除文件',
    fileCopiedSuccess: '已复制文件',
    exportSuccess: '已导出文件',
    exportFailed: '导出文件失败',
    importSuccess: '已导入文件',
    importFailed: '导入文件失败',
    importError: '导入文件时发生错误',
    noMatchingFiles: '没有找到匹配的文件',
    clickOrDragToUpload: '点击或拖拽文件到此区域上传'
  },

  // 快捷键模态框
  shortcuts: {
    title: '键盘快捷键',
    subtitle: '掌握这些快捷键，提升您的工作效率',
    fileOperations: '文件操作',
    editing: '编辑操作',
    navigation: '导航操作',
    selectionCopyPaste: '选择与复制粘贴',
    tableStructure: '表格结构',
    formatting: '格式化',
    interface: '界面操作',
    view: '视图切换',
    openImportFile: '打开/导入文件',
    saveAsMarkdown: '保存为 Markdown',
    exportMenu: '导出菜单',
    newTable: '新建表格',
    undoLastAction: '撤销上一步操作',
    redoLastAction: '重做上一步操作',
    redoAlternative: '重做（备选）',
    clearSelectedCells: '清空选中单元格',
    clearCellAndStartEditing: '清空单元格并开始编辑',
    moveToNextCell: '移动到下一个单元格',
    moveToPreviousCell: '移动到上一个单元格',
    moveToCellBelow: '移动到下方单元格',
    moveToCellAbove: '移动到上方单元格',
    navigateWithArrowKeys: '使用方向键导航',
    goToFirstCellInRow: '跳转到行首单元格',
    goToLastCellInRow: '跳转到行尾单元格',
    selectAllCells: '选择所有单元格',
    multiSelectCells: '多选单元格',
    rangeSelectCells: '范围选择单元格',
    copySelectedCells: '复制选中单元格',
    pasteFromClipboard: '从剪贴板粘贴',
    cutSelectedCells: '剪切选中单元格',
    addRowAbove: '在上方添加行',
    addRowBelow: '在下方添加行',
    addColumnLeft: '在左侧添加列',
    addColumnRight: '在右侧添加列',
    deleteSelectedRow: '删除选中行',
    deleteSelectedColumn: '删除选中列',
    toggleBold: '切换粗体',
    toggleItalic: '切换斜体',
    toggleUnderline: '切换下划线',
    alignLeft: '左对齐',
    alignCenter: '居中对齐',
    alignRight: '右对齐',
    toggleSidebar: '切换侧边栏',
    openSettings: '打开设置',
    showHelp: '显示帮助',
    showShortcuts: '显示快捷键',
    closeModalsOrCancelEditing: '关闭弹窗/取消编辑',
    tableView: '表格视图',
    markdownView: 'Markdown 视图',
    previewView: '预览视图',
    splitView: '分屏视图',
    zoomIn: '放大',
    zoomOut: '缩小',
    resetZoom: '重置缩放'
  },

  // 关于模态框
  about: {
    title: 'Markdown 表格编辑器',
    subtitle: '一个功能强大的 Markdown 表格可视化编辑应用',
    version: '版本',
    features: '主要功能',
    visualTableEditing: '可视化表格编辑，支持拖拽操作',
    realtimeMarkdownSync: '实时 Markdown 同步',
    multipleImportExportFormats: '支持多种导入导出格式',
    richStylingOptions: '丰富的样式和格式化选项',
    keyboardShortcutsSupport: '键盘快捷键支持',
    undoRedoFunctionality: '撤销/重做功能',
    multiLanguageSupport: '多语言支持',
    darkLightTheme: '深色/浅色主题',
    supportedFormats: '支持的格式',
    importFormats: '导入',
    exportFormats: '导出',
    keyboardShortcuts: '常用快捷键',
    openFile: '打开文件',
    saveFile: '保存为 Markdown',
    undo: '撤销',
    redo: '重做',
    toggleSidebar: '切换侧边栏',
    navigateCells: '单元格导航',
    madeWith: '用',
    byTheCommunity: '制作，由社区贡献',
    openSource: '开源',
    mitLicense: 'MIT 许可证',
    builtWith: '基于 React 和 Ant Design 构建',
    viewOnGithub: '在 GitHub 上查看',
    view: {
      title: '查看',
      zoomIn: '放大',
      zoomOut: '缩小',
      resetZoom: '重置缩放',
      toggleTheme: '切换主题'
    },
    proTips: '专业提示',
    tip1: '按住',
    tip1Suffix: '的同时使用方向键来选择范围',
    tip2: '使用',
    tip2Suffix: '来选择多个不相邻的单元格',
    tip3: '双击任意单元格快速开始编辑',
    tip4: '拖拽列边框来可视化调整列宽'
  }
}